import React, { useState, useEffect } from 'react';
import Header from '../components/Header.jsx';
import { adminAPI } from '../services/api';

const AdminUsers = () => {
  const [users, setUsers] = useState([]);
  const [search, setSearch] = useState('');
  const [loading, setLoading] = useState(true);

  const loadUsers = async () => {
    try {
      const response = await adminAPI.getUsers(search);
      setUsers(response.data.users || []);
    } catch (error) {
      console.error('Error loading users:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadUsers();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [search]);

  const toggleUserStatus = async (userId) => {
    if (!window.confirm('Are you sure you want to change this user\'s status?')) return;

    try {
      await adminAPI.toggleUserStatus(userId);
      loadUsers();
      alert('User status updated successfully');
    } catch (error) {
      alert('Error updating user status');
    }
  };

  return (
    <div>
      <Header />
      <main>
        <section className="section">
          <h1 style={{ color: 'var(--maroon)', fontFamily: "'Playfair Display',serif", marginBottom: '20px' }}>
            User Management
          </h1>

          {/* Search */}
          <div className="card" style={{ marginBottom: '20px', padding: '20px' }}>
            <input
              type="text"
              placeholder="Search by name, email or username..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              style={{ width: '100%' }}
            />
          </div>

          {/* Users Table */}
          {loading ? (
            <div style={{ textAlign: 'center', padding: '50px', color: 'var(--muted)' }}>
              Loading users...
            </div>
          ) : (
            <div className="card" style={{ padding: '0', overflow: 'auto' }}>
              <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                <thead>
                  <tr style={{ background: 'var(--glass)', borderBottom: '2px solid rgba(0,0,0,0.1)' }}>
                    <th style={{ padding: '16px', textAlign: 'left', fontWeight: '700' }}>User ID</th>
                    <th style={{ padding: '16px', textAlign: 'left', fontWeight: '700' }}>Name</th>
                    <th style={{ padding: '16px', textAlign: 'left', fontWeight: '700' }}>Email</th>
                    <th style={{ padding: '16px', textAlign: 'left', fontWeight: '700' }}>Username</th>
                    <th style={{ padding: '16px', textAlign: 'left', fontWeight: '700' }}>Phone</th>
                    <th style={{ padding: '16px', textAlign: 'left', fontWeight: '700' }}>Role</th>
                    <th style={{ padding: '16px', textAlign: 'left', fontWeight: '700' }}>Status</th>
                    <th style={{ padding: '16px', textAlign: 'left', fontWeight: '700' }}>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {users.map((user) => (
                    <tr key={user.user_id} style={{ borderBottom: '1px solid rgba(0,0,0,0.05)' }}>
                      <td style={{ padding: '16px' }}>{user.user_id}</td>
                      <td style={{ padding: '16px' }}>{user.full_name}</td>
                      <td style={{ padding: '16px' }}>{user.email}</td>
                      <td style={{ padding: '16px' }}>{user.username}</td>
                      <td style={{ padding: '16px' }}>{user.phone || '-'}</td>
                      <td style={{ padding: '16px' }}>
                        <span style={{
                          padding: '4px 8px',
                          borderRadius: '6px',
                          background: user.role === 'admin' ? 'rgba(122,19,43,0.1)' : 'rgba(59,130,246,0.1)',
                          color: user.role === 'admin' ? 'var(--maroon)' : '#3b82f6',
                          fontSize: '12px',
                          fontWeight: '600'
                        }}>
                          {user.role.toUpperCase()}
                        </span>
                      </td>
                      <td style={{ padding: '16px' }}>
                        <span style={{
                          padding: '4px 8px',
                          borderRadius: '6px',
                          background: user.is_active ? 'rgba(5,150,105,0.1)' : 'rgba(220,38,38,0.1)',
                          color: user.is_active ? '#059669' : '#dc2626',
                          fontSize: '12px',
                          fontWeight: '600'
                        }}>
                          {user.is_active ? 'ACTIVE' : 'INACTIVE'}
                        </span>
                      </td>
                      <td style={{ padding: '16px' }}>
                        {user.role !== 'admin' && (
                          <button
                            onClick={() => toggleUserStatus(user.user_id)}
                            style={{
                              padding: '6px 12px',
                              borderRadius: '6px',
                              border: 'none',
                              background: user.is_active ? '#dc2626' : '#059669',
                              color: '#fff',
                              cursor: 'pointer',
                              fontSize: '13px',
                              fontWeight: '600'
                            }}
                          >
                            {user.is_active ? 'Deactivate' : 'Activate'}
                          </button>
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}

          <div style={{ marginTop: '20px', textAlign: 'center' }}>
            <p style={{ color: 'var(--muted)' }}>Total Users: {users.length}</p>
          </div>
        </section>
      </main>
    </div>
  );
};

export default AdminUsers;
